export default "__VITE_ASSET__fc9f4468__"